import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Range, RangeCollection } from '../interfaces';
import { ApiService } from './api.service';

export type RangeFilters = {
  nom?: string
  order_by?: string;
  order?: string;
  page?: number;
  size?: number;
  fields?: {
    gammes?: string;
  }
  [x: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class RangeService extends ApiService {

  public get(id: string | number, filters: RangeFilters = {}): Observable<Range> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.get<Range>(`${this.apiUrl}/gammes/${id}${queryString}`)
    }
  
    public getCollection(filters: RangeFilters = {}): Observable<RangeCollection> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.get<RangeCollection>(`${this.apiUrl}/gammes/${queryString}`)
    }
  
    public post(data: Partial<Range>, filters: RangeFilters = {}): Observable<Range> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.post<Range>(`${this.apiUrl}/gammes/${queryString}`, data)
    }
  
    public patch(id: string | number, data: Partial<Range>, filters: RangeFilters = {}): Observable<Range> {
      const queryString = this.convertObjectToQueryString(filters) 
      return this.http.patch<Range>(`${this.apiUrl}/gammes/${id}${queryString}`, data)
    }
  
    public delete(id: string | number): Observable<string> {
      return this.http.delete<string>(`${this.apiUrl}/gammes/${id}`)
    }
}
